/*
 * Copyright (c) 2022-2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import pkgJson from '../../package.json';

export const environment = {
    // All @@{}@@ variables are replaced here by startup.sh and uses what is in the manifest
    // manifest.aks.{env}.yml
    production: false,
    fileUploadLimit: 200000000,
    uiVersion: pkgJson.version,
    environmentName: "@@{environmentName}@@",
    apiUrl: "@@{apiUrl}@@",
    APP_NAME: 'ESCI_TOOLS_UI',
    auth: {
        issuer: "https://login.microsoftonline.com/@@{tenantId}@@/v2.0",
        clientId: "@@{clientId}@@",
        redirectUri: window.location.origin,
        responseType: 'code',
        scope: 'openid profile email @@{clientId}@@/.default',
        showDebugInformation: true,
        // turn off validation that discovery document endpoints start with the issuer url defined above
        strictDiscoveryDocumentValidation: false,
        preserveRequestedRoute: true,
    },
};
